export const showCancelSubscription = (state, flag) => {
	state.showCancelSubscription = flag
}